import {
    Component,
    Input,
    Output,
    OnInit,
    OnChanges,
    forwardRef,
    AfterViewInit,
    SimpleChange } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare var jQuery: any;
declare var moment: any;

@Component({
    selector: 'itpx-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: [ './datepicker.component.css' ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatepickerComponent),
            multi: true
        }
    ]
})
export class DatepickerComponent implements ControlValueAccessor, OnChanges, AfterViewInit {
    @Input('value') _value: any;
    propagateChange = (_: any) => {};
    private id = Math.floor(Math.random() * 10000000000000001);

    ngAfterViewInit() {
        jQuery('#' + this.id).datepicker({
            format: 'dd/mm/yyyy',
            startDate: '-3d',
            defaultDate: 'today'
        }).on('changeDate', function(event) {
            this.onChange(event);
        });
    }

    ngOnChanges(changes: {[propKey: string]: SimpleChange}) { }

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    writeValue(value) {
        if (value) {
            this.value = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    private onChange(event: any) {
        let date = event.date;
        this.value = moment(date).unix();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/datepicker/datepicker.component.ts